module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAAXNSR0IArs4c6QAAAUlJREFUWEftmDFKBEEQRd/HQBQRTEQTDyCYGRiZiCYamu0JPIoX8ARqsukaGXoBMRbEzMBE0ESDksIdaDaYrnE7WqrT/n+q5tNdv6pFYJnZOrBUQL8kfQeomNkysFpgfyR91riqAXzfzJ6AvQI7knQb5F4AVwX2TtJZjZuJpWJ5xvpuSd7KQh2Z2RYwqdSVXWClUR37AJ774kna98R2gNdawZvZn6fAVkPJ16Ildijpofrrf3Z2Dowj2A7TKeYGezqA+BZNauqzbntHwEY0hqRxyCujH2yJy8SGqpmKpWJDFRiKzzO2OIpNZ0YfsaLrxb3P/T9CMDOfR0fAdgTvGEmX/+0uTiTdRwKZmSd1HcHOmnj2Y1HVurZnE7ipkA6AtUat9TvwWGmtj0N1LKekQsZUrBAjn6F6L7SZ5cOdKzTPJN7ujEUrdkvcL8qXCTY40L+jAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./statics/imgs/home/exitFullscreen.png
// module id = 403
// module chunks = 0